import {ApiArticle} from "#/src/definitions/ApiDefinitions";
import {Link} from "#/src/components/Link";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {truncateTitle} from "#/src/utils/string-utils";
import styled from "@emotion/styled";

const Container = styled(Link)`
  text-decoration: none;
`;

interface Props {
  article: ApiArticle
}

export function WorthSeeArticle({article}: Props) {
  return <div className="col-xl-4 col-md-6">
    <Container href={`/blog/${article.slug}`}>
      <article className="article-short">
        <figure className="short-img">
          <img src={`${Attachments.getUrl(AttachmentNamespace.ARTICLE, article)}-small`} alt={article.slug}/>
        </figure>
        <div className="short-content">
          <a href={`/blog?category=${article.category.slug}`} className="tag-small">{article.category.name}</a>
          <a href={`/blog/${article.slug}`} className="short-title">{truncateTitle(article.title)}</a>
        </div>
      </article>
    </Container>
  </div>
}